import { App, URLOpenListenerEvent } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { useEffect } from "react";
import { isStellarUri, parseStellarUri } from "../../services/stellar/stellar-uri/parse";
import { isValidDisbursementUrlFormat } from "../../services/redux/slices/opened_disbursement_uri/parse";
import { PluginListenerHandle } from "@capacitor/core";
import { store } from "../../services/redux/store";
import { setOpenedSep7Uri } from "../../services/redux/slices/opened_sep7_scheme/opened_stellar_uri_scheme";
import { setOpenedDisbursementUri } from "../../services/redux/slices/opened_disbursement_uri/opened_disbursement_uri";

const AppUrlListener: React.FC<{}> = () => {

  useEffect(() => {
    
    let listener: PluginListenerHandle | null = null;

    const setupListener = async () => {
      listener = await App.addListener('appUrlOpen', async (event: URLOpenListenerEvent) => {
        const dataUrl = event.url;
  
        // Close browser if it's open when we receive a deep link
        try {
          await Browser.close();
        } catch (e) {
          // Browser might not be open, ignore error
        }

        // Handle Stellar URIs - dispatch directly to Redux
        if (isStellarUri(dataUrl)) {
          const uri = parseStellarUri(dataUrl);
          store.dispatch(setOpenedSep7Uri(uri.toString()));
          return;
        }

        // Handle disbursement URIs - dispatch directly to Redux  
        if (isValidDisbursementUrlFormat(dataUrl)) {
          store.dispatch(setOpenedDisbursementUri(dataUrl));
          return;
        }
      });
    };

    setupListener();

    // Cleanup the listener when the component unmounts
    return () => {
      if (listener) {
        listener.remove();
      }
    };
  }, []);

  return null;
};


export default AppUrlListener;